import * as Solr from "../../../3x1010/Solr.js";
import VirtualList from "../../../components/common/VirtualList.component.js";
import InputKind from "./InputKind.js";
import QueryBuilder from "./QueryBuilder.js";

export default class NodeTerm {
  constructor(type, template, target, level, node, parent, callback) {
    this.type = type;
    this.template = template;
    this.target = target;
    this.level = level;
    this.node = node;
    this.parent = parent;
    this.callback = callback;
    this.mc = null;
    this.btnNot = null;
    this.clipsOptions = [];
  }

  init() {
    if (this.type === QueryBuilder.QUERY_BIANCA) {
      this.buildBianca();
    } else if (this.type === QueryBuilder.QUERY_NERA) {
      this.buildNera();
    }
  }

  dispose() {
    this.mc.remove();
  }

  buildNera() {
    // Crea il clip
    this.mc = jQuery(this.template).clone();
    this.mc.attr("id", this.node.id);
    this.target.append(this.mc);

    // Setta il path
    //debugger;
    jQuery(".js-path", this.mc).text(this.node.Field._label);

    // Setta la properties
    const props = [];
    if (this.node.Field.Relation) {
      props.push("relazione");
    } else if (this.node.Field.Type == Solr.FieldType.ComplexField) {
      props.push("entità");
    } else if (this.node.Field.Type == Solr.FieldType.StrField) {
      props.push("case sensitive");
    } else if (this.node.Field.Lookup) {
      props.push("lemmario");
    }
    for (let x = 0; x < props.length; x++) {
      const prop = jQuery("#template-property").clone();
      prop.removeAttr("id");
      prop.text(props[x]);
      jQuery(".js-properties", this.mc).append(prop);
    }

    // Clips vari
    this.btnDelete = jQuery(".js-cta-delete", this.mc);
    this.btnNot = jQuery(".js-cta-not", this.mc);

    // Pulsante not
    this.btnNot.on("click", this.onNot.bind(this, true));
    // Per il not la gestione è diversa perché può essere attivo o disattivo indipendentemente dagli altri
    if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
      this.onNot(false);
    }

    if (QueryBuilder.SIMPLE_MODE) {
      this.btnNot.hide();
    }

    // Remove
    this.btnDelete.on("click", this.onRemove.bind(this));

    // Inizializza la select del mode
    this.initSelectMode();

    // Infine setta l'input
    this.inputKind = new InputKind(jQuery(".js-input-kind-container", this.mc), this.node);
    this.inputKind.init();

    this.checkForNullNotNull();
  }

  onNot(lToggle) {
    if (lToggle) {
      this.node.Occurency = this.node.Occurency === Solr.QueryNodeOccurencyType.NOT ? Solr.QueryNodeOccurencyType.MUST : Solr.QueryNodeOccurencyType.NOT;
    }
    if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
      this.btnNot.addClass("is-active");
    } else {
      this.btnNot.removeClass("is-active");
    }
  }

  onRemove() {
    this.dispatch(QueryBuilder.EVENT_REMOVE_TERM, this);
  }

  initSelectMode() {
    let list = [];

    const ops = this.getOperators();

    //debugger;
    if (QueryBuilder.SIMPLE_MODE) {
      for (let x = 0; x < ops.length; x++) {
        list.push({
          id: ops[x],
          label: ops[x] ? NodeTerm["LABEL_" + ops[x].toUpperCase()] : NodeTerm["LABEL_NONE"],
        });
      }
    } else {
      for (let x = 0; x < ops.length; x++) {
        list.push({
          id: ops[x],
          label: ops[x] ? NodeTerm["COMPLEX_LABEL_" + ops[x].toUpperCase()] : NodeTerm["LABEL_NONE"],
        });
      }
    }

    this.select = jQuery(".js-vs-mode", this.mc);

    this.vSelect = new VirtualList(this.select[0], {
      options: list,
      entryHeight: 30,
      valueKey: "id",
      labelKey: "label",
      titleKey: this.explainOption.bind(this),
      isSelect: true,
      callback: this.handleSelectEvs.bind(this),
    });
    this.vSelect.init();
    this.vSelect.value = this.getSelectedValue(this.node.Compare);

    console.log(this.node.Compare);
  }

  handleSelectEvs(e) {
    switch (e.type) {
      case "change":
        this.onvSelectChange();
        break;
    }
  }

  onvSelectChange() {
    let lNormal = true;
    if (QueryBuilder.SIMPLE_MODE) {
      let val = this.vSelect.value;
      lNormal = this.setValue(val);
    }

    if (lNormal) {
      this.node.Compare = this.vSelect.value;
    }

    this.checkForNullNotNull();
  }

  setValue(val) {
    let lNormal = true;
    this.node.Occurency = Solr.QueryNodeOccurencyType.MUST;
    //debugger;
    if (this.node.Field.Type === Solr.FieldType.TextField && !this.node.Field.Lookup) {
      // Se è un TextField
      if (val === NodeTerm.TALLTERMSW_CONTAINS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.tALLTERMSw;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.MUST;
      } else if (val === NodeTerm.TALLTERMSW_NOT_CONTAINS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.tALLTERMSw;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.NOT;
      } else if (val === NodeTerm.TPHRASEW_UGUALE) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.tPHRASEw;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.MUST;
      }
    } else if (this.node.Field.Type === Solr.FieldType.TextField && this.node.Field.Lookup) {
      // Se è un TextField
      if (val === NodeTerm.SEQUALSW_CONTAINS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.sEQUALSw;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.MUST;
      } else if (val === NodeTerm.SEQUALSW_NOT_CONTAINS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.sEQUALSw;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.NOT;
      }
    } else if (this.node.Field.Type === Solr.FieldType.StrField) {
      // Se è un StrField
      if (val === NodeTerm.SEQUALSW_CONTAINS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.sEQUALSw;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.MUST;
      } else if (val === NodeTerm.SEQUALSW_NOT_CONTAINS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.sEQUALSw;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.NOT;
      }
    } else if (this.node.Field.Type === Solr.FieldType.LongPointField) {
      // Se è un LongPointField
      if (val === NodeTerm.NEQUALS_EQUALS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.nEQUALS;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.MUST;
      } else if (val === NodeTerm.NEQUALS_NOT_EQUALS) {
        lNormal = false;
        val = Solr.QueryNodeCompareType.nEQUALS;
        this.node.Compare = val;
        this.node.Occurency = Solr.QueryNodeOccurencyType.NOT;
      }
    }
    return lNormal;
  }

  getOperators() {
    // Costruisce la select delle modalità
    //debugger;
    let ops = null;
    let lPlain = true;
    if (QueryBuilder.SIMPLE_MODE) {
      const modes = this.node.Operators.slice();
      if (this.node.Field.Type === Solr.FieldType.TextField && !this.node.Field.Lookup) {
        lPlain = false;
        const tmp = [NodeTerm.TPHRASEW_UGUALE, NodeTerm.TALLTERMSW_CONTAINS, NodeTerm.TALLTERMSW_NOT_CONTAINS];
        for (let x = 0; x < modes.length; x++) {
          if (!modes[x].startsWith("t") && !modes[x].startsWith("s")) {
            tmp.push(modes[x]);
          }
        }
        ops = tmp;
      } else if (this.node.Field.Type === Solr.FieldType.TextField && this.node.Field.Lookup) {
        lPlain = false;
        const tmp = [NodeTerm.SEQUALSW_CONTAINS, NodeTerm.SEQUALSW_NOT_CONTAINS];
        for (let x = 0; x < modes.length; x++) {
          if (!modes[x].startsWith("s")) {
            tmp.push(modes[x]);
          }
        }
        ops = tmp;
      } else if (this.node.Field.Type === Solr.FieldType.StrField) {
        lPlain = false;
        const modes = this.node.Operators.slice();
        const tmp = [NodeTerm.SEQUALSW_CONTAINS, NodeTerm.SEQUALSW_NOT_CONTAINS];
        for (let x = 0; x < modes.length; x++) {
          if (!modes[x].startsWith("s")) {
            tmp.push(modes[x]);
          }
        }
        ops = tmp;
      } else if (this.node.Field.Type === Solr.FieldType.LongPointField) {
        lPlain = false;
        const tmp = [NodeTerm.NEQUALS_EQUALS, NodeTerm.NEQUALS_NOT_EQUALS];
        for (let x = 0; x < modes.length; x++) {
          if (!modes[x].startsWith("n")) {
            tmp.push(modes[x]);
          }
        }
        ops = tmp;
      }
    }
    if (lPlain) {
      ops = this.node.Operators;
    }
    //debugger;

    return ops;
  }

  getSelectedValue(compare) {
    if (QueryBuilder.SIMPLE_MODE) {
      if (this.node.Field.Type === Solr.FieldType.TextField && !this.node.Field.Lookup) {
        // Se è un TextField
        if (compare === Solr.QueryNodeCompareType.tALLTERMSw) {
          // Lo converte nel valore simulato a seconda che il not sia o no selezionato
          if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
            return NodeTerm.TALLTERMSW_NOT_CONTAINS;
          } else {
            return NodeTerm.TALLTERMSW_CONTAINS;
          }
        } else if (compare === Solr.QueryNodeCompareType.tPHRASEw) {
          // Lo converte nel valore simulato a seconda che il not sia o no selezionato
          return NodeTerm.TPHRASEW_UGUALE;
        }
      } else if (this.node.Field.Type === Solr.FieldType.TextField && this.node.Field.Lookup) {
        // Se è un TextField
        if (compare === Solr.QueryNodeCompareType.sEQUALSw) {
          // Lo converte nel valore simulato a seconda che il not sia o no selezionato
          if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
            return NodeTerm.SEQUALSW_NOT_CONTAINS;
          } else {
            return NodeTerm.SEQUALSW_CONTAINS;
          }
        }
      } else if (this.node.Field.Type === Solr.FieldType.StrField) {
        // Se è un StrField
        if (compare === Solr.QueryNodeCompareType.sEQUALSw) {
          // Lo converte nel valore simulato a seconda che il not sia o no selezionato
          if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
            return NodeTerm.SEQUALSW_NOT_CONTAINS;
          } else {
            return NodeTerm.SEQUALSW_CONTAINS;
          }
        }
      } else if (this.node.Field.Type === Solr.FieldType.LongPointField) {
        // Se è un LongPointField
        if (compare === Solr.QueryNodeCompareType.nEQUALS) {
          // Lo converte nel valore simulato a seconda che il not sia o no selezionato
          if (this.node.Occurency === Solr.QueryNodeOccurencyType.NOT) {
            return NodeTerm.NEQUALS_NOT_EQUALS;
          } else {
            return NodeTerm.NEQUALS_EQUALS;
          }
        }
      }
    }
    //debugger;
    return compare;
  }

  checkForNullNotNull() {
    // Se per caso Compare è cNOTNULL e cISNULL nasconde la parte prima
    if (this.node.Compare === Solr.QueryNodeCompareType.cNOTNULL || this.node.Compare === Solr.QueryNodeCompareType.cISNULL) {
      console.log("HIDE");
      jQuery(".js-input-kind-container", this.mc).hide();
    } else {
      console.log("SHOW");
      jQuery(".js-input-kind-container", this.mc).show();
    }
  }

  dispatch(type, data) {
    if (this.callback) {
      this.callback({
        type,
        data,
      });
    }
  }

  buildBianca() {
    // Crea il clip
    this.mc = jQuery(this.template).clone();
    this.mc.attr("id", this.node.id);
    this.target.append(this.mc);

    if (this.parent.node.Operator === Solr.QueryNodeBooleanType.AND) {
      jQuery(".js-relation-o", this.mc).hide();
    } else {
      jQuery(".js-relation-e", this.mc).hide();
    }

    // Setta il path
    jQuery(".js-node-path", this.mc).text(this.node.Field._label);
    // Il nome del nodo
    jQuery(".js-node-name", this.mc).text(this.node.Field.Label);

    // Infine setta l'input
    this.inputKind = new InputKind(jQuery(".js-input-kind-container", this.mc), this.node);
    this.inputKind.init();

    // Setta la properties
    const props = [];
    if (this.node.Field.Relation) {
      props.push("relazione");
    } else if (this.node.Field.Type == Solr.FieldType.ComplexField) {
      props.push("entità");
    } else if (this.node.Field.Type == Solr.FieldType.StrField) {
      props.push("case sensitive");
    } else if (this.node.Field.Lookup) {
      props.push("lemmario");
    }
    //debugger;
    for (let x = 0; x < props.length; x++) {
      const prop = jQuery("#template-property").clone();
      prop.removeAttr("id");
      prop.text(props[x]);
      jQuery(".js-properties", this.mc).append(prop);
      console.log(jQuery(".js-properties", this.mc));
    }

    // Inizializza le opzioni
    this.createOptions();

    this.checkForNullNotNullBianca();
  }

  createOptions() {
    const ops = this.getOperators();
    console.log(ops);
    for (let x = 0; x < ops.length; x++) {
      const op = jQuery("#template-input-mode").clone();
      op.removeAttr("id");
      op.text(NodeTerm["LABEL_" + ops[x].toUpperCase()]);
      //op.attr("data-op", ops[x]);
      jQuery(".js-input-mode", this.mc).append(op);
      //debugger;
      if (ops[x] === this.getSelectedValue(this.node.Compare)) {
        op.addClass("is-selected");
      }
      op.on("click", this.onSelect.bind(this, x));
      //debugger;
      op.attr("title", this.explainOption(ops[x]));

      this.clipsOptions.push(op);
    }
  }

  onSelect(op) {
    this.clipsOptions.forEach((el) => {
      el.removeClass("is-selected");
    });
    this.clipsOptions[op].addClass("is-selected");
    const ops = this.getOperators();
    const lNormal = this.setValue(ops[op]);
    if (lNormal) {
      this.node.Compare = ops[op];
    }
    this.checkForNullNotNullBianca();
  }

  checkForNullNotNullBianca() {
    // Se per caso Compare è cNOTNULL e cISNULL nasconde la parte prima
    if (this.node.Compare === Solr.QueryNodeCompareType.cNOTNULL || this.node.Compare === Solr.QueryNodeCompareType.cISNULL) {
      jQuery(".js-input-kind-container", this.mc).addClass("disable-input-kind");
      jQuery(".js-input-kind-container", this.mc).attr("inert", "");
    } else {
      jQuery(".js-input-kind-container", this.mc).removeClass("disable-input-kind");
      jQuery(".js-input-kind-container", this.mc).removeAttr("inert");
    }
  }

  explainOption(op) {
    if (op === NodeTerm.TPHRASEW_UGUALE) {
      return "Trova una parola o le parole nell’esatta sequenza in cui sono scritte.\nEsempio: Biancaneve e i sette nani\n“sette nani” trova dei risultati,\n“biancaneve nani” NON trova dei risultati perché la sequenza non è corretta\n";
    }
    if (op === NodeTerm.TALLTERMSW_CONTAINS) {
      return "Trova una parola o tutte le parole in qualunque ordine.\nEsempio: Biancaneve e i sette nani\n“sette nani” trova dei risultati,\n“biancaneve nani” trova dei risultati perché non è importante l’ordine delle parole";
    }
    if (op === NodeTerm.TALLTERMSW_NOT_CONTAINS) {
      return "Trova risultati che NON contengono una parola o le parole, in qualunque ordine.";
    }
    if (op === "cNOTNULL") {
      return "Trova risultati che hanno il campo in oggetto compilato con qualunque valore.";
    }
    if (op === "cISNULL") {
      return "Trova risultati che hanno il campo in oggetto vuoto (senza alcun valore).";
    }

    if (this.node.Field.Type == Solr.FieldType.StrField) {
      if (op === NodeTerm.SEQUALSW_CONTAINS) {
        // Case sensitive
        return "Trova una parola o tutte le parole in qualunque ordine e distingue tra maiuscole e minuscole.\nEsempio: Biancaneve e i sette nani\n“sette nani” trova dei risultati,\n“Biancaneve nani” trova dei risultati perché non è importante l’ordine delle parole\n“biancaneve nani” NON trova dei risultati perché “biancaneve” è scritto con la “b” minuscola.";
      }
      if (op === NodeTerm.SEQUALSW_NOT_CONTAINS) {
        // Case sensitive
        return "Trova risultati che NON contengono una parola o le parole, in qualunque ordine, e distingue tra maiuscole e minuscole.\nEsempio: Biancaneve e i sette nani\n“biancaneve” trova dei risultati con ”Biancaneve” perché la “b” iniziale non è maiuscola e quindi è una parola diversa.";
      }
    } else {
      if (op === NodeTerm.SEQUALSW_CONTAINS) {
        // Lemmario
        return "Trova la voce di lemmario selezionata e produce risultati che contengono quella voce ma possono contenerne anche altre.";
      }
      if (op === NodeTerm.SEQUALSW_NOT_CONTAINS) {
        // Lemmario
        return "Trova risultati che NON contengono la voce di lemmario selezionata ma possono contenere altre voci.";
      }
    }
  }
}

NodeTerm.TPHRASEW_UGUALE = "tPHRASEw_UGUALE";
NodeTerm.TALLTERMSW_CONTAINS = "tALLTERMSw_CONTAINS";
NodeTerm.TALLTERMSW_NOT_CONTAINS = "tALLTERMSw_NOT_CONTAINS";

NodeTerm.SEQUALSW_CONTAINS = "sEQUALSw_CONTAINS";
NodeTerm.SEQUALSW_NOT_CONTAINS = "sEQUALSw_NOT_CONTAINS";

NodeTerm.NEQUALS_EQUALS = "nEQUALS_EQUALS";
NodeTerm.NEQUALS_NOT_EQUALS = "nEQUALS_NOT_EQUALS";

NodeTerm.LABEL_TPHRASEW = "Parole in sequenza";
NodeTerm.LABEL_TALLTERMSW = "Tutte le parole";
NodeTerm.LABEL_TANYTERMW = "Una o più parole";

NodeTerm.LABEL_TPHRASEW_UGUALE = "è uguale a";
NodeTerm.LABEL_TALLTERMSW_CONTAINS = "contiene";
NodeTerm.LABEL_TALLTERMSW_NOT_CONTAINS = "non contiene";

NodeTerm.LABEL_CNOTNULL = "non è vuoto";
NodeTerm.LABEL_CISNULL = "è vuoto";

NodeTerm.LABEL_SEQUALSW = "contiene";

NodeTerm.LABEL_NEQUALS = "è uguale a";

NodeTerm.LABEL_SEQUALSW_CONTAINS = "contiene";
NodeTerm.LABEL_SEQUALSW_NOT_CONTAINS = "non contiene";

NodeTerm.LABEL_NEQUALS_EQUALS = "è uguale a";
NodeTerm.LABEL_NEQUALS_NOT_EQUALS = "è diverso da";

NodeTerm.LABEL_NONE = "   ";

NodeTerm.COMPLEX_LABEL_TPHRASEW = "Parole in sequenza (accetta *)";
NodeTerm.COMPLEX_LABEL_TALLTERMSW = "Tutte le parole (accetta *)";
NodeTerm.COMPLEX_LABEL_TANYTERMW = "Parti di parole (accetta *)";
NodeTerm.COMPLEX_LABEL_TPHRASE = "Parole in sequenza";
NodeTerm.COMPLEX_LABEL_TALLTERMS = "Tutte le parole";
NodeTerm.COMPLEX_LABEL_TANYTERM = "Una o più parole";
NodeTerm.COMPLEX_LABEL_SEQUALSW = "Uguale (accetta *)";
NodeTerm.COMPLEX_LABEL_SEQUALS = "Uguale";
NodeTerm.COMPLEX_LABEL_SSTARTS = "Inizia con";
NodeTerm.COMPLEX_LABEL_SENDS = "Finisce con";
NodeTerm.COMPLEX_LABEL_SCONTAINS = "Contiene";
NodeTerm.COMPLEX_LABEL_NEQUALS = "Uguale";
NodeTerm.COMPLEX_LABEL_DEQUALS = "Uguale";
NodeTerm.COMPLEX_LABEL_BEQUALS = "Uguale";
NodeTerm.COMPLEX_LABEL_CNOTNULL = "Non vuoto";
NodeTerm.COMPLEX_LABEL_CISNULL = "Vuoto";
